import { TokenDto } from '../../shared/models/franchise/franchise.model';
import { HelpersService } from '../../shared/utils/helpers/helpers.service';

export const selectUser = (state: { user: TokenDto }) => state.user;

export const selectAuthenticatedUser = (state: { user: TokenDto }) =>
  new HelpersService().userIsAuthenticated(state.user);
